/**
 * Base Map Details Page
 * 
 * Page for viewing base map details.
 */

import React from 'react';
import { SpaceBetween } from '@cloudscape-design/components';
import BaseMapDetails from '../../components/admin/BaseMapDetails';

const BaseMapDetailsPage: React.FC = () => {
  return (
    <SpaceBetween size="l">
      <BaseMapDetails />
    </SpaceBetween>
  );
};

export default BaseMapDetailsPage;
